import type { Dispatch, SetStateAction } from "react";
import type { DomainBorrowerStatus } from "@porchpass/api-client";

export const API_VERSION = "v1";

export interface UserDataProps {
  dealer_id?: string;
  application_id?: string;
  borrower_id?: string;
  auth_user_borrower_id?: string;
  status?: DomainBorrowerStatus;
  is_primary?: boolean;
  roles?: {
    borrower?: string;
    coborrowers?: string[];
  };
}

export type SetUserDataProps = Dispatch<SetStateAction<UserDataProps>>;

export interface UserContextProps {
  userData?: UserDataProps;
  setUserData?: SetUserDataProps;
}
